// @flow
/** @jsx h */
import { h } from 'preact';
import Banners from './banners';
import Merchants from './merchants';
import ShowDefaultBIC from './showDefaultBIC';
import BranchLocator from '../branchLocator';
import type { BicContentType } from '../../modelType/bicType';
import TopOffers from './topOffers';
import style from './style.css';
import Brands from './brands';
import Products from './Products';
import CampaignSpecificCategories from './campaignSpecificCategories';
import UserStatusCardContainer from './userStatusCardContainer';
import { connect } from 'react-redux';

// import HowToBuyPanel from './howToBuyPanel';
// import SubCategory from './subCategories';

type Props = {
  contentType: BicContentType,
  pageKey: string,
  bicAction: Function,
  hideEligiblePanel: Function,
};

const Content = ({
  contentType,
  pageKey,
  bicAction,
  hideEligiblePanel,
  offers,
  lenderDetailsList,
  userStatus,
  matches,
}: Props) => {
  const showOfferCarousel = () => {
    if (userStatus !== 'eligible') {
      return true;
    }
    for (const lender of lenderDetailsList) {
      for (const offer of offers)
        if (offer.supportedLenders[lender.lenderId]) {
          return true;
        }
    }
    return false;
  };
  switch (contentType) {
    case 'BANNERS':
      return (
        <div className={style.bannerContanerWrapper}>
          <div className={style.bannerContaner}>
            <Banners pageKey={pageKey} />
          </div>
        </div>
      );
    case 'CATEGORIES':
      return (
        <CampaignSpecificCategories pageKey={pageKey} bicAction={bicAction} />
      );
    case 'MERCHANTS':
      return (
        <Merchants pageKey={pageKey} header='Merchants' bicAction={bicAction} />
      );
    case 'BRANDS':
      return <Brands pageKey={pageKey} header='Brands' bicAction={bicAction} />;

    case 'OFFER_TILES':
      return showOfferCarousel() ? <TopOffers /> : null;
    case 'USER_STATUS_CONTEXT_CARD':
      return <UserStatusCardContainer matches={matches} />;
    case 'BRANCH_LOCATOR':
      return (
        <BranchLocator
          pageKey={pageKey}
          iconUrl='https://iccdn.in/img/location-icon.png'
        />
      );
    case 'SHOW_DEFAULT_BIC':
      return <ShowDefaultBIC pageKey={pageKey} />;

    case 'PRODUCTS':
      return <Products />;
    default:
      return null;
  }
};
const mapStateToProps = ({ buyWithInstacred, ntbConfig }) => {
  const { home } = buyWithInstacred || {};
  const { offers } = home;
  const { ntbDetails, userStatus } = ntbConfig;
  const { lenderDetailsList } = ntbDetails;
  return {
    offers,
    lenderDetailsList,
    userStatus,
  };
};

export default connect(mapStateToProps)(Content);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/Content.js